import React from "react"

import {PopoverParent} from "../../../../../@types"
import FieldProto from "../../../../../proto/field-proto"
import ModelEntity from "../../../../../../model2/model-entity"

const debug = false
// const debug = "FieldOffice_PopoverMenuMore"

export type PopoverMenuMoreProps = {
    parent  : PopoverParent //
    field   : FieldProto
    model?  : ModelEntity
}

export default class FieldOffice_PopoverMenuMore extends React.Component<PopoverMenuMoreProps> {

    onClick = ()=>{
        gd.navigation.goToOfficeLocations()
    }

    render() {
        return (
            <div className="help">
                <div className="flex-row-left-center" onClick={this.onClick}>
                    <div className="ui5-ico-15 i5-wrench m-r-8"/>
                    <div className="ui5-txt-link-small-no-accent">Manage locations</div>
                </div>
            </div>
        )
    }
}